/* @flow */

import * as React from "react";
import { Well } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

type Props = {
    errorMessage?: string;
};

export function ArticleCardError(props: Props) {
    return (
        <span>
            <Well className="well-sm">
                <div className="mfcss_card-article-2 mfcss_card-article-2--not-found mfcss_card-article-2--type-default">
                    <div className="mfcss_card-article-2--container-flex">
                        <div className="mfcss_card-article-2--image">
                            <img
                                alt={props.errorMessage}
                                src="/ordercapture/uidispatcher/static/app/assets/images/placeholder_food_item.png"
                                className="img-responsive"
                            />
                        </div>
                        <div className="mfcss_card-article-2--info">
                            <div className="mfcss_card-article-2--title">
                                <h4>
                                    <FormattedMessage id="EX_ARTICLE_BADGE_LOADING_ERROR" />
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </Well>
        </span>
    );
}
